import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { parse, isAfter, isBefore, addDays, subDays } from "date-fns";
export const CapturaExcepciones = () => {
  const { selectedNomina } = useOutletContext();
  const navigate = useNavigate();
  const toast = useRef(null);
  const [empleados, setEmpleados] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [concepto, setConcepto] = useState(null);
  const [valor, setValor] = useState("");
  const [empleado, setEmpleado] = useState(null);
  //const [errMsg, setErrMsg] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [show, setShow] = useState(false);
  const axiosPrivate = useAxiosPrivate();
  const { idCaptura } = useParams();
const [configSistema, setConfigSistema] = useState(null);

useEffect(() => {
  const fetchConfig = async () => {
    try {
      const res = await axiosPrivate.get("/NOM/configuracion/sistema");
      setConfigSistema(res.data);
    } catch (err) {
      console.error("Error al obtener configuración", err);
    }
  };

  fetchConfig();
}, []);
  const handleBack = () => {
    navigate(-1);
  };
  const getData = async () => {
    if (!selectedNomina) return;
    const resEmpleados = await axiosPrivate.get(
      `/NOM/empleados/Select/${selectedNomina.idNomina}`
    );
    setEmpleados(resEmpleados.data);
    if (!selectedNomina) return;

    try {
      const resConceptos = await axiosPrivate.get(
        `/NOM/conceptos/Select/${selectedNomina.idNomina}`
      );
      setConceptos(resConceptos.data);
    } catch (error) {
      console.log(error);
    }
  };
const validarDiaPermitido = (modulo) => {
  if (!selectedNomina || !configSistema) return true; // permitir por defecto si falta info

  const config = configSistema[modulo];
  if (!config) return true;

  const hoy = new Date();
  const fechaInicio = parse(selectedNomina.FechaInicial, "dd/MM/yyyy", new Date());
  const fechaFin = parse(selectedNomina.FechaFinal, "dd/MM/yyyy", new Date());

  let min = fechaInicio;
  let max = fechaFin;

  // Validación base por tipo de fechas
  switch (config.validacionFechas) {
    case "periodo":
      break; // ya está bien
    case "mes":
      min = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1);
      max = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth() + 1, 0);
      break;
    case "personalizado":
      if (config.rango?.inicio) min = new Date(config.rango.inicio);
      if (config.rango?.fin) max = new Date(config.rango.fin);
      break;
    default:
      // Opcional: puedes dejarlo vacío o agregar un log
      break;
  }

  const captura = config.capturaDias;
  if (captura) {
    if (captura.tipo === "primeros") {
      const nuevaMax = addDays(min, captura.cantidad - 1);
      if (nuevaMax < max) max = nuevaMax;
    } else if (captura.tipo === "ultimos") {
      const nuevaMin = subDays(max, captura.cantidad - 1);
      if (nuevaMin > min) min = nuevaMin;
    } else if (captura.tipo === "personalizado") {
      if (captura.rango?.inicio) min = new Date(captura.rango.inicio);
      if (captura.rango?.fin) max = new Date(captura.rango.fin);
    }
  }

  return !isBefore(hoy, min) && !isAfter(hoy, max);
};
  useEffect(() => {
    // setErrMsg("");
  }, [concepto, empleado]);

  useEffect(() => {
    getData();
  }, [selectedNomina]);

  useEffect(() => {
    const fetchFalta = async () => {
      console.log("Cargando falta con id:", idCaptura);
      if (idCaptura) {
        try {
          const response = await axiosPrivate.get(
            `/NOM/excepciones/${idCaptura}`
          );
          console.log("Captura response:", response.data);
          const { numero, noConcepto, valor } = response.data;

          setValor(valor);
          const empleadoEncontrado = empleados.find(
            (emp) => emp.numero === numero
          );
          const conceptoEncontrado = conceptos.find(
            (con) => Number(con.noConcepto) === Number(noConcepto)
          );
          if (empleadoEncontrado) {
            setEmpleado(empleadoEncontrado);
          } else {
            console.warn("Empleado no encontrado en la lista");
          }

          if (conceptoEncontrado) {
            console.log("Concepto encontrado:", conceptoEncontrado);
            setConcepto(conceptoEncontrado.noConcepto);
          } else {
            console.warn("Concepto no encontrado en la lista");
          }
        } catch (error) {
          console.error("Error al cargar la falta:", error);
        }
      }
    };
    if (empleados.length > 0 && conceptos.length > 0 && idCaptura) {
      fetchFalta();
    }
  }, [empleados, conceptos, idCaptura]);

  const handleSubmit = async () => {
    console.log(concepto);
    if (!empleado) {
      //setErrMsg("Indique el empleado para asignar las faltas.");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Indique el empleado para asignar las faltas.",
        life: 3000,
      });

      return;
    }
    if (!concepto) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Seleccione el concepto a capturar.",
        life: 3000,
      });
      return;
    }
  // 👇 Validación de captura permitida (usa el nombre de módulo en configSistema)
  

    const data = {
      empleado,
      concepto,
      valor,
      idNomina: selectedNomina.idNomina,
      periodo: `${
        selectedNomina.YearPeriodo
      }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`,
    };
    try {      
      const response = idCaptura
        ? await axiosPrivate.put(`/NOM/excepciones/${idCaptura}`, data)
        : await axiosPrivate.post("NOM/excepciones", data);
      console.log("Faltas response:", response.data);
      if (!idCaptura) {
        setEmpleado(null);
        setConcepto(null);
        setValor("");
      }
      setShow(false);
      setMensaje(response?.data.msg);
      toast.current.show({
        severity: "success",
        summary: "Éxito",
        detail: response?.data.msg,
        life: 3000,
      });
    } catch (err) {
      console.error(err);
      //setErrMsg("Error al registrar la excepción.");
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al registrar la excepción.",
        life: 3000,
      });
    }
  };

  return (
    <div className="p-4">
      <Toast ref={toast} />
      <h2 className="mb-4">Captura de bonos</h2>
      <div className="mb-3 flex justify-content-between">
        <Button
          label="Regresar"
          icon="pi pi-arrow-left"
          className="p-button-secondary"
          onClick={handleBack}
        />
        <Button
          label="Ver registros"
          icon="pi pi-list"
          className="p-button-info"
          onClick={() => navigate(`/bonos/listado?periodo=${
                    selectedNomina.YearPeriodo
                  }-${selectedNomina.PeriodoActual.toString().padStart(2, "0")}`)}
        />
      </div>
      {/* {errMsg && <small className="p-error">{errMsg}</small>} */}

      <div className="p-fluid p-formgrid grid">
        <div className="field col-12 md:col-6">
          <label htmlFor="empleado">Empleado</label>
          <Dropdown
            id="empleado"
            value={empleado}
            options={empleados}
            onChange={(e) => setEmpleado(e.value)}
            optionLabel="label"
            placeholder="Seleccione un empleado"
            filter
            showClear
          />
        </div>

        <div className="field col-12 md:col-6">
          <label htmlFor="concepto">Concepto</label>
          <Dropdown
            id="concepto"
            value={concepto}
            options={conceptos}
            onChange={(e) => setConcepto(e.value)}
            optionLabel="label"
            optionValue="noConcepto"
            placeholder="Seleccione un concepto"
            filter
            showClear
          />
        </div>

        <div className="field col-12 md:col-6">
          <label htmlFor="valor">Valor</label>
          <InputText
            id="valor"
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            placeholder="0"
          />
        </div>

        <div className="field col-12">
          <Button
            label="Registrar"
            icon="pi pi-check"
            onClick={() => {
              if (!validarDiaPermitido("bonos")) {
    toast.current.show({ 
        severity: "error",
        summary: "Error", 
        detail: "No se permite capturar bonos en esta fecha.",
        life: 3000,
      });
    return;
  }
              setShow(true);  }}
          />
        </div>
      </div>

      <Dialog
        header="Confirmación"
        visible={show}
        style={{ width: "50vw" }}
        modal
        onHide={() => setShow(false)}
      >
        <p>¿Está seguro que desea registrar el bono?</p>
        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            label="Cancelar"
            icon="pi pi-times"
            className="p-button-text"
            onClick={() => setShow(false)}
          />
          <Button
            label="Confirmar"
            icon="pi pi-check"
            autoFocus
            onClick={handleSubmit}
          />
        </div>
      </Dialog>
    </div>
  );
};

export default CapturaExcepciones;
